import { defineMessages } from 'react-intl';

export default defineMessages({
  cdraSheetTitle: 'legal-proceedings.risk.cdra_sheet.title',
  cdraSheetTheme: 'legal-proceedings.risk.cdra_sheet.theme',
  cdraSheetRulingNumber: 'legal-proceedings.risk.cdra_sheet.ruling_number',
  issuedOn: 'legal-proceedings.risk.cdra_sheet.issued_on',
  firstInstanceCourt: 'legal-proceedings.risk.cdra_sheet.first_instance_court',
  resolutionNumber: 'legal-proceedings.risk.cdra_sheet.resolution_number',
  fromAppeal: 'legal-proceedings.risk.cdra_sheet.from_appeal',
  reconciliationChapter:
    'legal-proceedings.risk.cdra_sheet.reconciliation_chapter',
  reconciliationChapterDate:
    'legal-proceedings.risk.cdra_sheet.reconciliation_chapter_date',
  reconciliationChapterFrom:
    'legal-proceedings.risk.cdra_sheet.reconciliation_chapter_from',
  friendlyImplementation:
    'legal-proceedings.risk.cdra_sheet.friendly_implementation',
  fileInformation: 'legal-proceedings.risk.cdra_sheet.file_information',
  lawyerName: 'legal-proceedings.risk.cdra_sheet.lawyer_name',
  attornyAdress: 'legal-proceedings.risk.cdra_sheet.attorny_adress',
  lawyerReference: 'legal-proceedings.risk.cdra_sheet.lawyer_reference',
  beneficiaryName: 'legal-proceedings.risk.cdra_sheet.beneficiary_name',
  finalAmount: 'legal-proceedings.risk.cdra_sheet.amount_agreed_up_on',
  lossDate: 'legal-proceedings.risk.cdra_sheet.loss_date',
  accidentType: 'legal-proceedings.risk.cdra_sheet.accident_type',
  traffic: { id: 'legal-proceedings.risk.cdra_sheet.traffic' },
  dots: { id: 'legal-proceedings.risk.cdra_sheet.dots' },
  employerName: 'legal-proceedings.risk.cdra_sheet.employer_name',
  registrationNumber:
    'legal-proceedings.risk.cdra_sheet.opposing_registration_number',
  insuredName: 'legal-proceedings.risk.cdra_sheet.insured_name',
  policyNumber: 'legal-proceedings.risk.cdra_sheet.policy_number',
  cnraTitle: { id: 'legal-proceedings.risk.cnra_sheet.title' },
  firstInstance: { id: 'legal-proceedings.risk.history.first_instance_sheet' },
  appeal: { id: 'legal-proceedings.risk.history.appeal_sheet' },
  board: 'legal-proceedings.risk.cdra_sheet.board',
});
